import {INFO_MODAL_NAME} from '../actions/infoModalActions';
import {
  ASSET_FILE_ITEM_NAME,
  ASSET_FILES_LIST_NAME,
  ASSET_FORM_ITEM_NAME,
  ASSET_LIST_NAME,
  CREATE_ASSET_FILE_NAME,
  CREATE_ASSET_FORM_NAME,
  CREATE_PROJECT_FILE_NAME,
  CREATE_PROJECT_FORM_NAME,
  CREATE_TEMPLATE_FILE_NAME,
  CREATE_TEMPLATE_FORM_NAME,
  PROJECT_FILE_ITEM_NAME,
  PROJECT_FILES_LIST_NAME,
  PROJECT_FORM_ITEM_NAME,
  PROJECT_LIST_NAME,
  TEMPLATE_LIST_NAME,
  UPDATE_ASSET_FILE_NAME,
  UPDATE_ASSET_FORM_NAME,
  UPDATE_ASSET_FORM_RESPONSE_NAME,
  UPDATE_PROJECT_FILE_NAME,
  UPDATE_PROJECT_FORM_NAME,
  UPDATE_PROJECT_FORM_RESPONSE_NAME,
  UPDATE_TEMPLATE_FILE_NAME,
  UPDATE_TEMPLATE_FORM_NAME,
} from '../redux/state';

/**
 *
 * CODE_TAG[Global-state-shape-aware]
 * @param rootState
 * @return {*}
 */
export function getState(rootState) {
  return rootState.requirements;
}

export function getAssetFileRequirement(rootState) {
  return getState(rootState)[ASSET_FILE_ITEM_NAME];
}

export function getProjectFileRequirement(rootState) {
  return getState(rootState)[PROJECT_FILE_ITEM_NAME];
}

export function getAssetFormRequirement(rootState) {
  return getState(rootState)[ASSET_FORM_ITEM_NAME];
}

export function getProjectFormRequirement(rootState) {
  return getState(rootState)[PROJECT_FORM_ITEM_NAME];
}

export function getAssetRequirementList(rootState) {
  return getState(rootState)[ASSET_LIST_NAME];
}

export function getProjectRequirementList(rootState) {
  return getState(rootState)[PROJECT_LIST_NAME];
}

export function getTemplateRequirementList(rootState) {
  return getState(rootState)[TEMPLATE_LIST_NAME];
}

/**
 * @param rootState
 * @return {RequirementsInfoModalState}
 */
export function getInfoModal(rootState) {
  return getState(rootState)[INFO_MODAL_NAME];
}

export function getAssetRequirementFilesList(rootState) {
  return getState(rootState)[ASSET_FILES_LIST_NAME];
}

export function getProjectRequirementFilesList(rootState) {
  return getState(rootState)[PROJECT_FILES_LIST_NAME];
}

export function getCreateAssetFileRequirement(rootState) {
  return getState(rootState)[CREATE_ASSET_FILE_NAME];
}

export function getCreateProjectFileRequirement(rootState) {
  return getState(rootState)[CREATE_PROJECT_FILE_NAME];
}

export function getCreateTemplateFileRequirement(rootState) {
  return getState(rootState)[CREATE_TEMPLATE_FILE_NAME];
}

export function getCreateAssetFormRequirement(rootState) {
  return getState(rootState)[CREATE_ASSET_FORM_NAME];
}

export function getCreateProjectFormRequirement(rootState) {
  return getState(rootState)[CREATE_PROJECT_FORM_NAME];
}

export function getCreateTemplateFormRequirement(rootState) {
  return getState(rootState)[CREATE_TEMPLATE_FORM_NAME];
}

export function getUpdateAssetFileRequirement(rootState) {
  return getState(rootState)[UPDATE_ASSET_FILE_NAME];
}

export function getUpdateProjectFileRequirement(rootState) {
  return getState(rootState)[UPDATE_PROJECT_FILE_NAME];
}

export function getUpdateTemplateFileRequirement(rootState) {
  return getState(rootState)[UPDATE_TEMPLATE_FILE_NAME];
}

export function getUpdateAssetFormRequirement(rootState) {
  return getState(rootState)[UPDATE_ASSET_FORM_NAME];
}

export function getUpdateProjectFormRequirement(rootState) {
  return getState(rootState)[UPDATE_PROJECT_FORM_NAME];
}

export function getUpdateTemplateFormRequirement(rootState) {
  return getState(rootState)[UPDATE_TEMPLATE_FORM_NAME];
}

export function updateAssetFormReqResponse(rootState) {
  return getState(rootState)[UPDATE_ASSET_FORM_RESPONSE_NAME];
}

export function updateProjectFormReqResponse(rootState) {
  return getState(rootState)[UPDATE_PROJECT_FORM_RESPONSE_NAME];
}



// WEBPACK FOOTER //
// ./src/js/requirements/reducers/state.js